<script>
  import { Tabs, TabsItem } from "@gl/design-system";
  import { Route, Router, navigate } from "svelte-routing";
  import { onMount } from "svelte";
  import { _, user, url } from "../../stores/index";
  import MeData from "./MeData.svelte";
  import MePreferences from "./MePreferences.svelte";

  let selectedTab = "data";

  const setSelectedTabFromPathname = () => {
    if ($url.pathname.includes("preferences")) {
      selectedTab = "preferences";
    } else {
      selectedTab = "data";
    }
  };

  $: if ($url) setSelectedTabFromPathname();

  onMount(() => {
    setSelectedTabFromPathname();
  });
</script>

<svelte:head>
  <title>
    {$_("users.me.profile")} | {$_("access-manager")}
  </title>
</svelte:head>

<div class="main me p-6" style="height:100%">
  <h1 class="gl-title">
    {$_("common.profile")}: {$user.data.firstName}
    {$user.data.lastName}
  </h1>
  <Tabs class="mt-5">
    <TabsItem
      selected={selectedTab === "data"}
      on:click={() => {
        selectedTab = "data";
        navigate("/me/data");
      }}
    >
      {$_("users.data")}
    </TabsItem>
    <TabsItem
      selected={selectedTab === "preferences"}
      on:click={() => {
        selectedTab = "preferences";
        navigate("/me/preferences");
      }}
    >
      {$_("common.preferences")}
    </TabsItem>
  </Tabs>

  <Router>
    <Route path="/data">
      <MeData />
    </Route>
    <Route path="/preferences">
      <MePreferences />
    </Route>
  </Router>
</div>

<style>
  .me {
    margin-left: 262px;
    width: 75%;
    margin: 0 auto;
  }
</style>
